import {OnboardingState, OnboardingStep} from './OnboardingStore.types';

import {Store} from '@/stores/Store';

const initialOnboardingState: OnboardingState = {
  currentOnboardingModal: null,
};

export class OnboardingStore extends Store<OnboardingState> {
  constructor() {
    super(initialOnboardingState);
  }

  public getIsUserEnergyOnboarding = (): boolean => {
    return this.getState().currentOnboardingModal === OnboardingStep.UserEnergy;
  };

  public openUserEnergyOnboarding = (): void => {
    this.setState({
      ...this.getState(),
      currentOnboardingModal: OnboardingStep.UserEnergy,
    });
  };

  public closeOnboarding = (): void => {
    this.setState({
      ...this.getState(),
      currentOnboardingModal: null,
    });
  };
}
